import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
const Notification = ({message, type, onClose}) => {
    let bgColor = "";
    let textColor = "";
    switch(type) {
        case "success":
            bgColor = "bg-green-500";
            textColor = "text-white";
            break;
        case "error":
            bgColor = "bg-red-500";
            textColor = "text-white";
            break;
        case "warning":
            bgColor = "bg-yellow-500";
            textColor = "text-white";
            break;
        case "info":
            bgColor = "bg-blue-500";
            textColor = "text-white";
            break;
        default:
            bgColor = "bg-gray-500";
            textColor = "text-white";
            break;
    }
    return (
        
        <div className={`fixed top-5 left-1/2 transform -translate-x-1/2 p-4 rounded-md ${bgColor} ${textColor} min-w-[400px]`}>
        <div className="flex justify-between  row items-start">
            <span>{message}</span>
            <button onClick={onClose} className="text-xl font-bold ml-4">&times;</button>
        </div>
    </div>
      
    )
}
export default Notification;